export enum BADGE_TYPES {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
  default = 'default',
}

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'

export const DATE_FORMAT_YMD = 'YYYY-MM-DD'

export const DATE_FORMAT_DMY = 'DD/MM/YYYY'

export const DATE_TIME_FORMAT_DMY = 'DD/MM/YYYY | HH:mm'

export const DATE_FORMAT_HM = 'HH:mm'

export const DAYS_IN_WEEK = 7
